<template>
    <div class="login-container">
        <div class="logo-container">
            <img class="logo" src="../assets/logo.png">
            <h1>NURI</h1>
        </div>

        <b-field label="">
            <b-input v-model="email" placeholder="UserId"></b-input>
        </b-field>
        <b-field label="">
            <b-input type="password"
                v-model="password"
                placeholder="Password"
                password-reveal>
            </b-input>
        </b-field>

        <button class="button login" type="button" @click="login">Login</button>
        <router-link class="register" to="/signup">Register</router-link> 
    </div>
</template>

<script>
import userService from '../services/userService.js'

export default {
  name: 'login',
  data() {
    return{
      email: '',
      password:''
    }
  },
  methods:{
      login:function(){
          var me = this;

          userService.setPersistence().then(
              function(){
                userService.getUserLoginPromise(me.email + '@nuri.com', me.password).then(
                    function(user)
                    {
                        me.$router.replace('home')
                        me.$store.commit('setNotification',{state:'success',text:'Login successfully'})
                    },
                    function(err){
                        me.$store.commit('setNotification',{state:'error',text:err.message})
                    }
                )
              },
            function(err){
                me.$store.commit('setNotification',{state:'error',text:err.message})
            }
          )
          
      },
      signup: function(){
        var me = this;
        me.$router.push({ name: 'signup'});
      }
  }
}
</script>

<style>
.login-container h1 {
    font-size: 12px;
}
.login-container input{
    margin: 10px 0px;
    height:40px!important;
    border-radius: 0px!important;
}

.login-container .register{
    font-size: 12px;
    float:left;
}

.login-container .login{
    margin-top: 60px;
    height:40px;
    background: #5Eb0e5;
    color:white;
}

.login:hover{
    background: #6eb7e7;
    border: 0px;
    color:white;
}

.login-container {
    margin: 0 auto;
    width: 400px;
    height: 400px;
    padding: 30px;
    border-radius: 0px;
    background: rgba(255, 255, 255, 0.4);
     border: 0px solid #6eb7e7;
    -webkit-box-shadow: 0px 0px 2px #5eb0e5;
    box-shadow: 0px 0px 2px #5eb0e5;
}
.login-container .icon{
    right: 5px!important;
    top: 18px!important;
}
.login-container h2{
    padding:10px;
    text-align: center;
}
.logo-container{
    width: 50px;
    height:100px;
    margin: 0 auto;
}
</style>